import Checkbox from '@material-ui/core/Checkbox';
import { CheckboxProps } from '@material-ui/core/Checkbox/Checkbox';
import { Theme, makeStyles } from '@material-ui/core/styles';
import CheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import React, { FunctionComponent } from 'react';

const checkboxSize = 48;
const useStyles = makeStyles((theme: Theme) => ({
	root: {
		padding: '0',
		width: checkboxSize,
		height: checkboxSize,
	},
	sizeIcon: {
		height: checkboxSize,
		width: checkboxSize,
	},
}));

interface Props {
	checked: boolean;
	dataCy?: string;
	setChecked(newChecked: boolean): void;
	setRef?(input: any): any;
}

export const GenericCheckbox: FunctionComponent<Props & CheckboxProps> = (
	props
) => {
	const classes = useStyles();

	return (
		<Checkbox
			classes={{
				root: classes.root,
			}}
			icon={<CheckBoxOutlineBlankIcon className={classes.sizeIcon} />}
			checkedIcon={<CheckBox className={classes.sizeIcon} />}
			checked={props.checked}
			onChange={() => props.setChecked(!props.checked)}
			data-cy={props.dataCy}
			inputRef={props.setRef}
			color="primary"
		/>
	);
};
